<template lang="pug">
a.internal-link.link-highlight(
  :href="fullLinkHref"
  target="_blank")
  | {{ internalLinkTitle }}
</template>

<script>
import internalLinkDestinations from '@/mixins/internalLinkWebDestinations.js';
import authSvc from '@/services/authSvc.js';

export default {
  name: 'AttachmentInternalLink',
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  computed: {
    fullLinkHref() {
      const httpsRegex = new RegExp('^https:');
      if (httpsRegex.test(this.linkHref)) {
        return encodeURI(this.linkHref);
      } else {
        return authSvc.getWebuiUrl() + encodeURI(this.linkHref);
      }
    },
    internalLinkTitle() {
      return this.attachment.attachmentMeta && this.attachment.attachmentMeta.title
        ? this.attachment.attachmentMeta.title
        : this.attachment.content;
    }
  },
  data() {
    return {
      linkHref: null
    };
  },
  methods: {
    buildInternalLinkHref() {
      const internalLinkArray = this.attachment.content.split(':');
      const linkBase = internalLinkArray[0];
      const linkSuffixes = internalLinkArray.slice(1);
      const destinationHasOptions =
        internalLinkDestinations[linkBase] &&
        typeof internalLinkDestinations[linkBase]['options'] !== 'undefined';

      if (typeof internalLinkDestinations[linkBase] === 'undefined') {
        console.warn(`Invalid internal link base: ${linkBase}`);
        return;
      }

      if (destinationHasOptions) {
        this.buildLinkWithOptions(linkBase, linkSuffixes);
      } else if (linkBase === 'search') {
        this.buildSearchLink(linkBase, linkSuffixes);
      } else {
        this.buildPlainLink(linkBase, linkSuffixes);
      }
    },
    buildLinkWithOptions(linkBase, linkSuffixes) {
      if (linkBase === 'tools' && linkSuffixes[0] === 'sleep_entry') {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        this.linkHref = (
          internalLinkDestinations[linkBase]['options'][linkSuffixes[0]] +
          '?day=' +
          date.toISOString().split('T')[0]
        );
      } else {
        this.linkHref =
          internalLinkDestinations[linkBase]['options'][linkSuffixes[0]];
      }
    },
    buildSearchLink(linkBase, linkSuffixes) {
      if (linkSuffixes.length > 0) {
        this.linkHref = this.replaceUrlToken(
          internalLinkDestinations[linkBase]['suffix'],
          'suffix:0',
          linkSuffixes[0]
        );
      } else {
        this.linkHref = internalLinkDestinations[linkBase]['noSuffix'];
      }
    },
    buildPlainLink(linkBase, linkSuffixes) {
      const linkUrlTemplate = internalLinkDestinations[linkBase];

      if (!this.urlTemplateHasToken(linkUrlTemplate)) {
        this.linkHref = linkUrlTemplate;
      } else {
        this.linkHref = linkSuffixes.reduce((acc, suffix, index) => {
          const token = `suffix:${index}`;
          return this.replaceUrlToken(acc, token, suffix);
        }, linkUrlTemplate);
      }
    },
    replaceUrlToken(url, token, replacement) {
      return url.replace(`{{${token}}}`, replacement);
    },
    urlTemplateHasToken(url) {
      const tokenRegex = new RegExp('[{]{2}suffix:[0-9][}]{2}', 'gm');
      return tokenRegex.test(url);
    }
  },
  mounted() {
    this.buildInternalLinkHref();
  },
  updated() {
    this.buildInternalLinkHref();
  }
};
</script>

<style lang="scss" scoped>
</style>
